import {Money, MoneyObject} from "../../stem-core/localization/Money";
import {BaseStore, globalStore} from "../../stem-core/state/Store";


@globalStore
export class Wallet extends BaseStore("Wallet", {}, MoneyObject) {
    declare balance: number;

    getBalance(): Money {
        // TODO: rename for consistency for all MoneyObjects?
        return new Money(this.balance, this.getCurrency());
    }

    getAmount(): Money {
        return this.getBalance();
    }

    // TODO: this function should be deprecated
    static getWallet(): Wallet | undefined {
        return this.all()[0];
    }
}
